import { render, staticRenderFns } from "./redisMonitor.vue?vue&type=template&id=53898c67&"
import script from "./redisMonitor.vue?vue&type=script&lang=js&"
export * from "./redisMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports